import React, { useState, useRef, useEffect  } from 'react'; // useRef 추가
import questionsData from '../../data/question.json'; // JSON 파일 import
import styles from './Test.module.css'; // CSS 모듈 사용
import { useNavigate } from 'react-router-dom'; // useNavigate import 추가
import axios from 'axios';

import HeaderSection from '../all_pages/HeaderSection';

import what_your_best_at from '../../assets/a_diagnostic_test/what_your_best_at.svg'
import Not_a_test from '../../assets/a_diagnostic_test/Not_a_test.svg'
import Development_potential from '../../assets/a_diagnostic_test/Development_potential.svg'


import physical_skills from '../../assets/a_diagnostic_test/physical_skills.svg';
import dexterity_skills from '../../assets/a_diagnostic_test/dexterity_skills.svg';
import spatial_perception_skills from '../../assets/a_diagnostic_test/spatial_perception_skills.svg';
import musical_skills from '../../assets/a_diagnostic_test/musical_skills.svg';
import Creativity_skills from '../../assets/a_diagnostic_test/Creativity_skills.svg';
import linguistic_skills from '../../assets/a_diagnostic_test/linguistic_skills.svg';
import logical_skills from '../../assets/a_diagnostic_test/logical_skills.svg';
import self_reflection_skills from '../../assets/a_diagnostic_test/self_reflection_skills.svg';
import interpersonal_skills from '../../assets/a_diagnostic_test/interpersonal_skills.svg';
import enviromental_friendliness_skills from '../../assets/a_diagnostic_test/enviromental_friendliness_skills.svg';
import artistic_visual_skills from '../../assets/a_diagnostic_test/artistic_visual_skills.svg';

import registeredResultIcon from '../../assets/a_diagnostic_test/skiptest_img.svg'

// import resultStyles from './TestResultPage.module.css';  // TestResultPage.module.css를 다른 이름으로 import

const apiUrl = process.env.REACT_APP_API_URL;  // 환경 변수로 API URL 불러오기

const Test = () => {
  const navigate = useNavigate(); // 네비게이션 훅
  const [showModal, setShowModal] = useState(false); // 모달 상태
  const [step, setStep] = useState(1);  // 현재 페이지 상태
  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  // 로컬 스토리지에서 로그인한 유저의 토큰을 가져옵니다
  const token = localStorage.getItem('accessToken');

  // 토큰이 제대로 불러와졌는지 콘솔에 출력
  // console.log("JWT 토큰:", token);


  const layoutRef  = useRef(null);
  const questionContainerRef = useRef(null); // questionContainer에 대한 참조 생성. 상단 스크롤 

  const [answers, setAnswers] = useState({}); // 각 질문의 답변 저장
  const [scores, setScores] = useState(Array(11).fill(0)); // 11개의 유형별 점수 저장
  
  const questionsPerPage = 6; // 한 페이지에 표시할 문항 수
  const [currentPage, setCurrentPage] = useState(0); // 현재 페이지

  const [isSubmitting, setIsSubmitting] = useState(false);

    //// 검사 스킵 기능
    const [skippage, setskippage] = useState(false); // 1.5 페이지 여부
    const [selectedKeywords, setSelectedKeywords] = useState([]);

    const skiptestpage = () => {
      if (selectedKeywords.length !== 3) {
        alert("3개의 키워드를 선택해주세요.");
        return;
      }
    
      // // 선택된 키워드 점수 계산
      // const finalScores = Object.keys(skillDescriptions).map((key) =>
      //   selectedKeywords.includes(key) ? 42 : 0
      // );


      // 선택된 키워드 점수 계산
      const skillKeys = Object.keys(skillDescriptions);
      const finalScores = skillKeys.map((key) =>
        selectedKeywords.includes(key) ? 42 : 0
      );


      // 콘솔에 값 출력
      console.log("최종 점수(finalScores):", finalScores); // 디버깅용

      // 상위 3개 스킬 계산
      const topSkills = getTopSkills(finalScores); // finalScores를 전달
      console.log("계산된 topSkills:", topSkills);

      // // 결과 전송 전 확인
      // alert("결과가 콘솔에 출력되었습니다. 다음 단계로 진행합니다.");
      // 결과 전송
      submitTestResults(finalScores);

      // 다음 단계로 이동
      nextStep();
    

    };
    

  /// 이동 관련

    // 네비게이션 함수 생성
    const goToDashboard = () => {
      navigate('/dashboard'); // 절대 경로로 이동
    };


  /////////////////////////////////////////////////////////////////////////////// 이동 관련 끝.



  // JWT 토큰 로그인 관련

    // 컴포넌트 내부에 useEffect 추가
  useEffect(() => {
    // 로컬 스토리지에서 로그인한 유저의 토큰을 가져옵니다
    const token = localStorage.getItem('accessToken');
    
    // 토큰이 제대로 불러와졌는지 콘솔에 출력
    // console.log("useEffect에서 불러온 JWT 토큰:", token);
    
    if (!token) {
      console.error("토큰이 존재하지 않습니다. 사용자 인증이 필요합니다.");
      
    }
  }, []);

  /////////////////////////////////////////////////////////////////////////////// JWT 토큰 로그인 관련 끝.



  //// 상태가 잘 변하는지 확인하는 로그 부분 (스탭 로그 확인)
  useEffect(() => {
    // console.log("Current step:", step); // 현재 step 상태를 확인하는 로그
  }, [step]);
  /////////////////////////////////////////////////////////////////////////////// 스탭 로그 확인 끝.


  //// 모달 관련

    // 모달을 띄우는 함수
    const handleBackClick = () => {
      setShowModal(true); // 모달 열기
    };
  
    // 모달을 닫고 dashboard로 이동
    const closeAndNavigate = () => {
      setShowModal(false);
      navigate('/mypage');
    };
  
    // 모달 닫기만
    const closeModal = () => {
      setShowModal(false);
    };

    /////////////////////////////////////////////////////////////////////////////// 모달 관련 끝.


    //// 상단바 네비게이션 이동
    const handleCancelClick = () => {
      navigate('/mypage'); // 취소 버튼 클릭 시 mypage로 이동
    };
    ////


    /// 페이지 상단
  // 페이지가 변경될 때마다 최상단으로 스크롤
  useEffect(() => {
      if (layoutRef.current) {
        layoutRef.current.scrollIntoView({
              behavior: 'smooth',
              block: 'start', // 최상단으로 이동
          });

          // 상단바 높이만큼 더 위로 이동
          window.scrollTo({
              top: -100, // 상단바의 높이를 반영하여 더 위로 이동
              behavior: 'smooth',
          });
      }
  }, [currentPage, step]);

    ///// 페이지 상단 끝.


  // 페이지 상단으로 이동
  const nextPage = () => {
    // 현재 페이지 점수 계산 후 저장
    const pageScore = calculateCurrentPageScore();
    const newScores = [...scores];
    newScores[currentPage] = pageScore;
    setScores(newScores);

    // 다음 페이지로 넘어가기
    if (currentPage < questionsData.types.length - 1) {
        setCurrentPage((prevPage) => prevPage + 1);
    } else {
        console.log("최종 결과: ", newScores);
        setStep(3);  // 결과 페이지로 이동
    }
};
  


  // 백엔드에 결과를 보내는 함수
// 백엔드에 결과를 보내는 함수
const submitTestResults = (finalScores) => {
  setIsSubmitting(true);
  const data = {
    physical_skills: finalScores[0],
    dexterity_skills: finalScores[1],
    spatial_perception_skills: finalScores[2],
    musical_skills: finalScores[3],
    creativity_skills: finalScores[4],
    linguistic_skills: finalScores[5],
    logical_skills: finalScores[6],
    self_reflection_skills: finalScores[7],
    interpersonal_skills: finalScores[8],
    environmental_friendliness_skills: finalScores[9],
    artistic_visual_skills: finalScores[10],
  };

  // 전송 데이터 콘솔에 출력
  console.log("전송할 데이터:", data);

  // axios POST 요청으로 백엔드에 결과 저장
  axios.post(`${apiUrl}/aptitude_test/user-skills/`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => {
    console.log("성공적으로 저장됨:", response.data);

    // 상위 3개 스킬 계산
    // const topSkills = getTopSkills();
    const topSkills = getTopSkills(finalScores); // finalScores 전달
    console.log("계산된 topSkills:", topSkills);

    // 로컬스토리지에 상위 3개 적성 영역 저장
    localStorage.setItem('topSkills', JSON.stringify(topSkills));
    localStorage.setItem('cacheTime', new Date().getTime());  // 캐시 시간 저장

    setStep(3);  // 결과 페이지로 이동
  })
  .catch((error) => {
    console.error("저장 중 에러 발생:", error);
  })
  .finally(() => setIsSubmitting(false));
};


  

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const skillDescriptions = {
    physical_skills: {
      name: "신체, 운동 능력",
      description: "또래보다 뛰어난 운동신경과<br>체력을 가질 확률이 높고,<br>신체 학습과 순발력도 빠를 것으로 보입니다.",
      img: physical_skills
    },
    dexterity_skills: {
      name: "손재능",
      description: "손으로 만드는 일을 잘 해내는 경향이 있습니다. 다른 친구들보다 만들어 낸 결과물이 정교하거나 정확합니다.",
      img: dexterity_skills
    },
    spatial_perception_skills : {
      name: "공간지각력",
      description: "글로 쓰인 이미지를 머릿속에서 입체적으로 떠올리고 생각할 수 있습니다. 공간 배치 및 공간기억의 능력을 잘 발휘합니다.",
      img: spatial_perception_skills
    },
    musical_skills : {
      name: "음악능력",
      description: "정확한 음정으로 노래하거나 악기를 연주하는 능력이 뛰어납니다. 음을 잘 구분하고 감상하는 능력이 있습니다.",
      img: musical_skills
    },
    creativity_skills : {
      name: "창의력",
      description: "호기심이 많고 독특한 방법으로 문제를 해결하는 경향이 있습니다. 융통성 있는 아이디어를 낼 가능성이 높습니다.",
      img: Creativity_skills
    },
    linguistic_skills : {
      name: "언어능력",
      description: "말이나 글로 생각과 감정을 표현하는 능력이 뛰어 납니다. 다른 사람의 말과 글을 잘 이해할 수 있습니다.",
      img: linguistic_skills
    },
    logical_skills : {
      name: "수리, 논리력",
      description: "수학적 개념을 이해하고 계산하고 해결하는 능력을 가지고 있습니다. 논리적인 사고로 분석, 응용하는 것을 잘합니다.",
      img: logical_skills
    },
    self_reflection_skills : {
      name: "자기 성찰 능력",
      description: "자신의 생각과 감정을 알고 감정 조절을 합니다. 스스로 목표를 세우고 실행하며 결과에 대한 자기 책임을 잘 인정합니다.",
      img: self_reflection_skills
    },
    interpersonal_skills: {
      name: "대인관계 능력",
      description: "다른 사람의 마음이 자연스럽게 이해 되고 공감 능력이 높은 편입니다. 사람들과 잘 어울리며 관계를 잘 유지합니다.",
      img: interpersonal_skills
    },
    enviromental_friendliness_skills: {
      name: "자연친화력",
      description: "동물이나 식물에 대한 관심과 이해도가 높습니다. 자연보호에 관심이 많으며, 자연에 대해 깊게 탐구하려고 합니다.",
      img: enviromental_friendliness_skills
    },
    artistic_visual_skills: {
      name: "예술 시각 능력",
      description: "선, 색, 공간 등을 조화롭게 구성할 수 있으며 주변 사물이나 환경의 아름다움을 느끼고 표현하는데 익숙합니다.",
      img: artistic_visual_skills
    },
    // 나머지 능력들도 추가 가능
  };

    // // 상위 3개 항목 계산
    // const getTopSkills = () => {
    //   const skillKeys = Object.keys(skillDescriptions);
    //   // 점수를 기준으로 내림차순 정렬
    //   const sortedSkills = skillKeys.sort((a, b) => scores[skillKeys.indexOf(b)] - scores[skillKeys.indexOf(a)]);
    //   // 상위 3개의 항목만 반환 (동점자가 있을 경우에도 순서대로 3개만 선택)
    //   return sortedSkills.slice(0, 3);
    // };

    // // 상위 3개 항목 계산 수정 진행 중
    const getTopSkills = (finalScores) => {
      const skillKeys = Object.keys(skillDescriptions);
    
      // 점수와 스킬 키를 매핑
      const skillScores = skillKeys.map((key, index) => ({
        skill: key,
        score: finalScores[index], // 전달된 finalScores 기반으로 점수 매핑
      }));
    
      console.log("스킬 점수 매핑:", skillScores); // 디버그용
    
      // 점수 기준으로 내림차순 정렬
      const sortedSkills = skillScores.sort((a, b) => b.score - a.score);
    
      console.log("정렬된 스킬:", sortedSkills); // 디버그용
    
      return sortedSkills.slice(0, 3).map((item) => item.skill); // 상위 3개 반환
    };
    
    

  const startQuestionIndex = currentPage * questionsPerPage;
  const endQuestionIndex = startQuestionIndex + questionsPerPage;
  // const currentQuestions = currentType?.questions?.slice(startQuestionIndex, endQuestionIndex); // currentType과 questions가 존재하는지 확인

  // 현재 페이지에 맞는 유형 및 질문을 가져오는 코드 수정
  const currentType = questionsData.types[currentPage]; // currentPage에 따라 올바른 유형을 참조
  const currentQuestions = currentType?.questions; // currentType에 따라 올바른 질문 목록을 참조

    // 현재 페이지의 모든 질문이 답변되었는지 확인
    const isNextButtonDisabled = currentQuestions.some((question) => !answers[question.id]);

  

  // 답변 선택 처리
  const handleAnswerSelect = (questionId, score) => {
    setAnswers({
      ...answers,
      [questionId]: score,
    });
    // // 선택한 답변을 현재 유형에 더함
    // const newScores = [...scores];
    // newScores[currentPage] += score; // 현재 유형의 점수에 선택한 점수 더하기
    // setScores(newScores);

    // 로그 추가: 선택된 질문과 점수, 현재 페이지의 점수 업데이트
    // console.log(`질문 ${questionId}에 대한 답변: ${score}`);
    // console.log(`현재 유형의 점수 업데이트:`, newScores);
  };

  /// 현재 페이지 질문 ID를 기반으로 점수 합계
  const calculateCurrentPageScore = () => {
    // 현재 페이지의 질문 ID를 기반으로 점수를 합산
    let pageScore = 0;
    const currentQuestions = questionsData.types[currentPage].questions;
    currentQuestions.forEach((question) => {
      const answer = answers[question.id];
      if (answer) {
        pageScore += answer; // 해당 질문에 대한 답변을 합산
      }
    });
    
    return pageScore;
  };
  /// 현재 페이지 질문 ID를 기반으로 점수 합계 끝. 



//// 검사 결과 페이지 컴포넌트
const TestResultPage = ({ topSkills, skillDescriptions, finalScores }) => {
  const navigate = useNavigate();

  // 결과를 백엔드로 전송하고 대시보드로 이동하는 함수
  const handleFinishClick = async () => {
    try {
      // 백엔드로 결과 전송
      await submitTestResults(finalScores);
      // 성공적으로 전송되면 대시보드로 이동
      navigate('/mypage');
    } catch (error) {
      console.error('결과 전송 중 오류 발생:', error);
    }
  };







  return (
    <div className={styles.layout2}>
      <HeaderSection title="적성 유형 파악" />
      <div className={styles.resultContainer}>
        <h1 className={styles.resulth1}>글로의<br />상위 3개 적성 영역을<br />알려드릴게요!</h1>
        <p className={styles.resultp}>11가지의 적성 영역 중에서<br /> 가장 점수가 높은 3가지를 보여드릴게요!</p>
        {topSkills.map((skill, index) => (
          <div key={index} className={styles.skillBlock}>
            <img src={skillDescriptions[skill].img} alt={skillDescriptions[skill].name} className={styles.skillImage} />
            <div className={styles.resulttextContainer}>
              <h2 className={styles.skillsresulth2}>{skillDescriptions[skill].name}</h2>
              <p className={styles.skillsresultp} dangerouslySetInnerHTML={{ __html: skillDescriptions[skill].description }} />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.nextButtonContainer}>
        <button onClick={handleFinishClick} className={styles.nextButton}>
          끝내기
        </button>
      </div>
    </div>
  );
};



  /////////////////////////////////////////////////////////////////////////////////////////////////////////////


  const getScrollableElement = (el) => {
    while (el && el !== document.body) {
      const hasScrollableContent = el.scrollHeight > el.clientHeight;
      const overflowYStyle = window.getComputedStyle(el).overflowY;
      const isScrollable = overflowYStyle !== 'visible' && overflowYStyle !== 'hidden';
  
      if (hasScrollableContent && isScrollable) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  };
  
  // 페이지에서 스크롤이 가능한 요소를 찾고 콘솔에 출력
  const scrollableElement = getScrollableElement(document.querySelector('.layout'));
  // console.log('스크롤 가능한 요소:', scrollableElement);

///////////////////



//// 검사 스킵 기능
// const handleKeywordSelect = (name) => {
//   setSelectedKeywords((prev) => {
//     if (prev.includes(name)) {
//       // 이미 선택된 경우 제거
//       return prev.filter((keyword) => keyword !== name);
//     }
//     // 선택되지 않은 경우 추가 (최대 3개 제한)
//     return prev.length < 3 ? [...prev, name] : prev;
//   });
// };


const handleKeywordSelect = (key) => {
  if (selectedKeywords.includes(key)) {
    setSelectedKeywords((prev) => prev.filter((item) => item !== key));
  } else if (selectedKeywords.length < 3) {
    setSelectedKeywords((prev) => [...prev, key]);
  } else {
    alert("최대 3개의 키워드만 선택 가능합니다.");
  }
};







  return (
    <div className={styles.layout} ref={layoutRef}>

        {step === 1 && !skippage && (
          <>
            <HeaderSection
                title="적성 유형 파악"
                onBack={handleBackClick} // 뒤로 가기 버튼을 눌렀을 때 모달을 띄움
                onCancel={handleBackClick} // 취소 버튼을 눌렀을 때 mypage로 이동
              />
            <div className={styles.agreementContainer}>
              {/* 모달 */}
                {showModal && (
                  <div className={styles.modalBackdrop}>
                    <div className={styles.modalContent}>
                      <h2 className={styles.modalTitle}>정말 페이지를 떠나실건가요?</h2>
                      <p className={styles.modalDescription}>
                        이전 페이지로 돌아가면, <br />
                        진단검사 내용은 초기화됩니다.
                      </p>
                      <div className={styles.modalButtons}>
                        <button className={styles.leftButton} onClick={closeAndNavigate}>
                          네.<br /> 그만할래요.
                        </button>
                        <button className={styles.rightButton} onClick={closeModal}>
                          아니요.<br /> 계속할래요.
                        </button>
                      </div>
                    </div>
                  </div>
                )}

              <div className={styles.middletext}>
                {/* 타이틀 */}
                <h1 className={styles.middletexth1}>글로의 적성 유형을 <br></br> 조사해볼게요!</h1>
                <p className={styles.description}>글로의 적성 유형에 따라, 주어지는 퀘스트의 유형이 달라요!</p>
                {/* <p className={styles.description}></p> */}

                <div className={styles.testmaincontainer}>
                  {/* 그림 */}
                  <div className={styles.testcontainer} style={{ backgroundColor: '#252525', borderRadius: '16px' }}>
                    <div className={styles.imageContainer}>
                      <img src={what_your_best_at} alt="글로가 제일 잘하는게 무엇일까요?" className={styles.image} />
                    </div>
                    <div className={styles.textContainer}>
                      <h2>글로가 제일 잘하는게 무엇일까요?</h2>
                      <p>적성은 내가 가지고 있는 능력을 말해요!<br></br> 본인이 가지고 있는<br/> 현재 능력을 알아볼까요?</p>
                      {/* <p>내 글록이 가지고 있는 <br /> 현재 능력을 알아볼까요?</p> */}
                    </div>
                  </div>

                  <div className={styles.testcontainer} style={{ backgroundColor: '#252525', borderRadius: '16px' }}>
                    <div className={styles.imageContainer} >
                      <img src={Not_a_test} alt="본 내용은 시험이 아니에요" className={styles.Not_a_test} />
                    </div>
                    <div className={styles.textContainer}>
                      <h2>본 내용은 시험이 아니에요</h2>
                      <p>시간 제한이 없어요! <br/> 정답 역시 존재하지 않으니, <br/>솔직하게 답변해주세요!</p>
                      {/* <p>내 글록이 가지고 있는 <br /> 현재 능력을 알아볼까요?</p> */}
                    </div>
                  </div>

                  <div className={styles.testcontainer} style={{ backgroundColor: '#252525', borderRadius: '16px' }}>
                    <div className={styles.imageContainer}>
                      <img src={Development_potential} alt="글록은 계속 발전할 수 있어요!" className={styles.Development_potential} />
                    </div>
                    <div className={styles.textContainer}>
                      <h2>적성은 계속 발전할 수 있어요!</h2>
                      <p>결과 내용은 현재 상태만 측정한 내용이에요! <br/> 예상하는 결과가 아니더라도,<br/>실망할 필요가 없어요!</p>
                    </div>
                  </div>
                  {/* 그림 끝 */}
                </div>
                  {/* 타이틀 끝 */}
                  <p className={styles.already}>
                    {' '}
                    <button className={styles.linkButton} onClick={() => setskippage(true)}>이미 진단검사를 진행했어요!</button>
                  </p>
              </div>



            </div>



              <div className={styles.nextButtonContainer}>
                <button 
                  className={styles.nextButton} 
                  onClick={nextStep}
                >
                  다음으로
                </button>
              </div>
            </>
          )}


{step === 1 && skippage && (
  <>
    <HeaderSection
      title="기존 검사결과 입력"
      onBack={() => setskippage(false)} // 뒤로 가기 버튼을 누르면 1번 페이지로 이동
    />
    <div className={styles.pageContainer}>
      <p className={styles.mainTitle}>11가지 키워드 선택하기</p>
      <p className={styles.subTitle}>
        이전 직업적성검사 결과의 <br />
        상위 3개 키워드를 선택해주세요.
      </p>

      {/* 키워드 선택 리스트 */}
      <ul className={styles.keywordList}>
        {Object.keys(skillDescriptions).map((key) => (
          <li
            key={key}
            className={`${styles.keywordItem} ${
              selectedKeywords.includes(key) ? styles.selected : ''
            }`}
            onClick={() => handleKeywordSelect(key)} // 수정된 선택 로직
          >
            {selectedKeywords.includes(key) ? (
              <span className={styles.selectedKeyword}>✔ {skillDescriptions[key].name}</span>
            ) : (
              <span>{skillDescriptions[key].name}</span>
            )}
          </li>
        ))}
      </ul>

      {/* 다음 버튼 */}
      <div className={styles.nextButtonContainer}>
        <button
          className={styles.nextButton}
          onClick={skiptestpage} // 선택 완료 후 2번 페이지로 이동
          disabled={selectedKeywords.length < 3} // 3개 선택하지 않으면 비활성화
        >
          다음으로
        </button>
      </div>
    </div>
  </>
)}

{step === 3 && skippage && (
  <>
    <HeaderSection
      title="기존 검사결과 입력"
      // onBack={() => {
      //   setStep(1); // 이전 스텝으로 이동
      //   // setskippage(false); // 스킵 플래그 초기화/
      // }}
      // onCancel={() => navigate('/mypage')} // 취소 시 마이페이지로 이동
    />
    <div className={styles.pageContainer}>
      {/* 메인 타이틀 */}
      <p className={styles.mainTitle_end}>이전 검사결과가<br/> 등록되었어요!</p>

      {/* 이미지 및 아이콘 */}
      <div className={styles.skipimageContainer}>
        <div className={styles.animatedIcon}>
          {/* 여기에 애니메이션 또는 아이콘을 추가 */}
          <img className={styles.animatedImage} src={registeredResultIcon} alt="등록된 결과" />
        </div>
      </div>

      {/* 완료 버튼 */}
      <div className={styles.nextButtonContainer}>
        <button
          className={styles.nextButton}
          onClick={() => navigate('/mypage')} // 완료 후 결과 페이지로 이동
        >
          완료
        </button>
      </div>
    </div>
  </>
)}



{step === 2 && !skippage && (
  <>
    <HeaderSection
      title="적성 유형 파악"
      onBack={handleBackClick} // 뒤로 가기 버튼을 눌렀을 때 모달을 띄움
      onCancel={null} // 특정 페이지에서 취소 버튼 숨기기
    />

    {/* 프로세스 바 */}
    <div className={styles.progressWrapper}>
      <div className={styles.progressContent}>
        {/* 진행 퍼센트 텍스트 */}
        <span className={styles.progressText}>
          {Math.floor(((currentPage + 1) / 12) * 100)}%
        </span>
        {/* 프로그레스 바 */}
        <div className={styles.progressBarContainer}>
          <div
            className={styles.progressBar}
            style={{ width: `${(currentPage + 1) / 12 * 100}%` }} // 진행 상황 계산
          ></div>
        </div>
      </div>
    </div>


    {/* 모달 */}
    {showModal && (
      <div className={styles.modalBackdrop}>
        <div className={styles.modalContent}>
          <h2 className={styles.modalTitle}>정말 페이지를 떠나실건가요?</h2>
          <p className={styles.modalDescription}>
            이전 페이지로 돌아가면, <br />
            진단검사 내용은 초기화됩니다.
          </p>
          <div className={styles.modalButtons}>
            <button className={styles.leftButton} onClick={closeAndNavigate}>
            네.<br /> 그만할래요.
            </button>
            <button className={styles.rightButton} onClick={closeModal}>
              아니요.<br />계속할래요.
            </button>
          </div>
        </div>
      </div>
    )}

        {/* 데이터가 로드되었는지 확인하고 질문을 표시 */}
        {currentType && currentType.questions ? (
      <div className={styles.questionContainer} >
        {currentQuestions.map((question, index) => (
          <div
            key={question.id}
            className={`${styles.questionBlock} ${
              index % 2 === 0 ? styles.oddBackground : ''
            }`} // 홀수 인덱스에만 배경색 적용
          >
            <h3 className={styles.questionTitle}>{question.question}</h3>


            <div className={styles.radioScale}>
                <div className={styles.radioWrapper}>
                  {[...Array(7).keys()].map((i) => {
                    const score = i + 1;
                    return (
                      <label key={score} className={styles.radioLabel}>
                        <input
                          type="radio"
                          name={`question-${question.id}`}
                          value={score}
                          checked={answers[question.id] === score}
                          onChange={() => handleAnswerSelect(question.id, score)}
                          className={styles.radioInput}
                        />
                        <span className={styles.radioCircle}></span>
                        {/* <span className={styles.radioText}>{score}</span> */}
                      </label>
                    );
                  })}
                {/* </div> */}
                </div>
                <div className={styles.labelContainer}>
                  <div className={styles.labelLeft}>
                    <span>전혀 그렇지 않다</span>
                  </div>
                  <div className={styles.labelRight}>
                    <span>매우 그렇다</span>
                  </div>
                </div>



            </div>


            {/* <div className={styles.labelRight}>
              <span>매우 그렇다</span>
            </div> */}
            
          </div>
        ))}

        <div className={styles.nextButtonContainer}>
          <button 
            onClick={nextPage} 
            className={styles.nextButton} 
            disabled={isNextButtonDisabled}>
            {currentPage < questionsData.types.length - 1 ? '다음으로' : '결과 보기'}
          </button>
        </div>
      </div>
    ) : (
      <p>로딩 중...</p>
    )}

</>
    )}

{step === 3 && !skippage && (
  <TestResultPage
    topSkills={getTopSkills(scores)} // finalScores로 scores 전달
    skillDescriptions={skillDescriptions}
    finalScores={scores}
    submitTestResults={submitTestResults}
  />


)}




  </div>
  );
};

export default Test;
